<template>
    <v-menu
        v-model="menu_open"
        content-class="overflow-y-hidden dropmenu pa-1 elevation-0"
        left
        nudge-right="50"
        offset-y
        attach
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <slot :on="on" />
        </template>
        <v-card v-if="isMobile" class="pa-2">
            <v-card-title class="ma-0 pt-2 pb-1 px-4">
                <span class="font-weight-medium line-height">{{ $t("Add time") }}</span>
            </v-card-title>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 mb-2 shrink">
                    <BillableSwitch
                        :value="timeEntry.billable"
                        @change="toggle_billable()"
                    />
                </v-col>
                <v-col><small>{{ $t("Billable") }}</small></v-col>
            </v-row>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 shrink">
                    <v-menu
                        v-model="isCalendarOpen"
                        lazy
                        offset-y
                        :close-on-content-click="false"
                    >
                        <template v-slot:activator="{ on }">
                            <span
                                class="caption font-weight-medium n3--text"
                            >
                                {{ $t("Date") }}
                            </span>
                            <input
                                class="input-box date-input"
                                type="text"
                                readonly
                                :value="
                                    timeEntry.calendarDate | format_date
                                "
                                v-on="on"
                                @focus="inputOnFocus"
                                @blur="
                                    date_changed(timeEntry.calendarDate)
                                "
                            />
                        </template>
                        <v-date-picker
                            v-if="isCalendarOpen"
                            v-model="timeEntry.calendarDate"
                            min="1900-01-01"
                            color="primary"
                            no-title
                            :locale="locale"
                            :first-day-of-week="firstDayOfWeek"
                            @input="date_picked(timeEntry.calendarDate)"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 shrink">
                    <span class="caption font-weight-medium n3--text">{{ $t("Start") }}</span>
                    <input
                        :value="formatTime(timeEntry.startTime)"
                        class="input-box time-input"
                        type="text"
                        :class="error != '' ? 'validation-error' : ''"
                        @click.stop
                        @focus="inputOnFocus"
                        @change="startTimeChanged"
                    />
                </v-col>
            </v-row>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 shrink">
                    <span class="caption font-weight-medium n3--text">{{ $t("End") }}</span>
                    <input
                        :value="formatTime(timeEntry.endTime)"
                        class="input-box time-input"
                        type="text"
                        :class="error != '' ? 'validation-error' : ''"
                        @click.stop
                        @focus="inputOnFocus"
                        @change="endTimeChanged"
                    />
                </v-col>
            </v-row>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 shrink">
                    <span class="caption font-weight-medium n3--text">{{ $t("Duration") }}</span>
                    <input
                        ref="durationInput"
                        v-model="timeEntry.duration"
                        class="input-box time-input"
                        type="text"
                        :class="error != '' ? 'validation-error' : ''"
                        @click.stop
                        @focus="inputOnFocus"
                        @change="durationChanged"
                    />
                </v-col>
            </v-row>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 ">
                    <v-simple-checkbox
                        v-model="splitDuration"
                        class="ml-1 mr-2"
                        color="primary"
                    />
                    <small>{{ $t("Split duration equally") }}</small>
                </v-col>
            </v-row>

            <v-row no-gutters justify="start" align="start">
                <v-col class="px-2 ">
                    <v-btn color="primary" @click="saveTimeEntry">
                        <span>{{ $t("Add") }}</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-card v-if="!isMobile" class="pa-2 card-container">
            <v-row no-gutters justify="start" align="start">
                <v-col style="max-width: 500px">
                    <v-card-title class="ma-0 pt-2 pb-1 px-4">
                        <span class="font-weight-medium line-height">
                            {{ $t("Add time") }}</span>
                    </v-card-title>
                    <v-row align="end">
                        <v-col class="px-2 ml-4 mb-2 shrink" style="max-width: 50px">
                            <BillableSwitch
                                :value="timeEntry.billable"
                                @change="toggle_billable()"
                            />
                        </v-col>
                        <v-col class="px-2 shrink">
                            <v-menu
                                v-model="isCalendarOpen"
                                lazy
                                offset-y
                                :close-on-content-click="false"
                            >
                                <template v-slot:activator="{ on }">
                                    <span
                                        class="caption font-weight-medium n3--text"
                                    >
                                        {{ $t("Date") }}
                                    </span>
                                    <input
                                        class="input-box date-input"
                                        type="text"
                                        readonly
                                        :value="
                                            timeEntry.calendarDate | format_date
                                        "
                                        v-on="on"
                                        @focus="inputOnFocus"
                                        @blur="
                                            date_changed(timeEntry.calendarDate)
                                        "
                                    />
                                </template>
                                <v-date-picker
                                    v-if="isCalendarOpen"
                                    v-model="timeEntry.calendarDate"
                                    min="1900-01-01"
                                    color="primary"
                                    no-title
                                    :locale="locale"
                                    :first-day-of-week="firstDayOfWeek"
                                    @input="date_picked(timeEntry.calendarDate)"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col class="px-2 shrink">
                            <span class="caption font-weight-medium n3--text">
                                {{ $t("Start") }}
                            </span>
                            <input
                                :value="formatTime(timeEntry.startTime)"
                                class="input-box time-input"
                                type="text"
                                :class="error != '' ? 'validation-error' : ''"
                                @click.stop
                                @focus="inputOnFocus"
                                @change="startTimeChanged"
                            />
                        </v-col>
                        <v-col class="px-2 shrink">
                            <span class="caption font-weight-medium n3--text">
                                {{ $t("End") }}
                            </span>
                            <input
                                :value="formatTime(timeEntry.endTime)"
                                class="input-box time-input"
                                type="text"
                                :class="error != '' ? 'validation-error' : ''"
                                @click.stop
                                @focus="inputOnFocus"
                                @change="endTimeChanged"
                            />
                        </v-col>

                        <v-col class="px-2 shrink">
                            <span class="caption font-weight-medium n3--text">
                                {{ $t("Duration") }}
                            </span>
                            <input
                                ref="durationInput"
                                v-model="timeEntry.duration"
                                class="input-box time-input"
                                type="text"
                                :class="error != '' ? 'validation-error' : ''"
                                @click.stop
                                @focus="inputOnFocus"
                                @change="durationChanged"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        class="ml-4 mt-2"
                        justify="space-between"
                        align="center"
                    >
                        <v-col>
                            <v-row>
                                <v-simple-checkbox
                                    v-model="splitDuration"
                                    class="ml-1 mr-2"
                                    color="primary"
                                />
                                <span>{{ $t("Split duration equally") }}</span>
                            </v-row>
                        </v-col>
                        <v-col class="shrink mr-4">
                            <v-btn
                                color="primary"
                                @click="saveTimeEntry"
                            >
                                <span>{{ $t("Add") }}</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-menu>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import { ref, computed, reactive, watch } from "@vue/composition-api";
import KeyInputPattern from "@/composables/KeyInputPattern";
import {
    parseTimeDuration,
    formatTimeDuration,
    formatTimeFromStr,
    parseTime,
    formatTime,
    formatSysDate, formatSysTime
} from "@/plugins/formatting";
import {
    differenceInMinutes,
    subMinutes,
    addMinutes
} from "date-fns"
import TaskModule from "@/store/modules/task";
import AccountModule from "@/store/modules/account";
import BillableSwitch from "@/views/Task/TimeEntries/BillableButton";

export default {
    name: "SplitTimeMenu",
    components: {
        BillableSwitch
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        isBillable: {
            type: Boolean,
            default: true
        }
    },
    setup(props, ctx) {
        const { inputOnFocus } = KeyInputPattern();

        const { saveTimeEntries } = TaskModule();
        const { current_account } = AccountModule();

        const timeEntry = reactive({
            startTime: null,
            endTime: null,
            duration: null,
            billable: props.isBillable ? 1 : 0,
            calendarDate: formatSysDate(new Date()),
            personId: current_account.value.id
        });

        const menu_open = ref(false);
        const isCalendarOpen = ref(false);
        const error = ref("");
        const startTimeDateObj = ref(null);
        const endTimeDateObj = ref(null);
        const splitDuration = ref(false);

        function calculateDifference(newerTime, oldertime) {
            const hourDifference = Math.floor(
                differenceInMinutes(newerTime, oldertime) / 60
            );
            const minuteDifference =
                differenceInMinutes(newerTime, oldertime) % 60;

            return { hourDifference, minuteDifference };
        }

        function setTimeValues(calendarTime, inputTime, type) {
            // prepare the values to pass inside date object, note that month is index in date object so you always need to subtract by 1
            const year = calendarTime.split("-")[0];
            const month = parseInt(calendarTime.split("-")[1]) - 1;
            const day = calendarTime.split("-")[2];
            const hour = inputTime.split(":")[0];
            const minute = inputTime.split(":")[1];

            if (type === "startTime") {
                startTimeDateObj.value = new Date(
                    year,
                    month,
                    day,
                    hour,
                    minute,
                    0,
                    0
                );
            }
            if (type === "endTime") {
                endTimeDateObj.value = new Date(
                    year,
                    month,
                    day,
                    hour,
                    minute,
                    0,
                    0
                );
            }
        }

        function setFormattedDuration(hourDifference, minuteDifference) {
            const secondsFromHour = hourDifference * 60 * 60;
            const secondsFromMinutes = minuteDifference * 60;
            const result = secondsFromHour + secondsFromMinutes;
            timeEntry.duration = formatTimeDuration(result);
        }

        function startTimeChanged(val) {
            //get the time eg: 11:00:00
            timeEntry.startTime = parseTime(val.target.value);

            // this sets either endTimeDateObj or endTimeDateObj, which is needed for calculating time differences
            setTimeValues(
                timeEntry.calendarDate,
                timeEntry.startTime,
                "startTime"
            );

            const { hourDifference, minuteDifference } = calculateDifference(
                new Date(),
                startTimeDateObj.value
            );

            //calculate duration based on different conditions
            if (timeEntry.endTime !== null) {
                const {
                    hourDifference,
                    minuteDifference
                } = calculateDifference(
                    endTimeDateObj.value,
                    startTimeDateObj.value
                );
                if (minuteDifference >= 0 || hourDifference >= 0) {
                    setFormattedDuration(hourDifference, minuteDifference);
                }
            }
            if (minuteDifference >= 0 && timeEntry.endTime === null) {
                setFormattedDuration(hourDifference, minuteDifference);
            }
            if (minuteDifference < 0) {
                timeEntry.duration = null;
            }
        }

        function endTimeChanged(val) {
            const data = parseTime(val.target.value);

            // this is needed incase you remove endTime, then the startTime can calculate duration
            if (val.target.value === "") {
                return (timeEntry.endTime = null);
            }

            timeEntry.endTime = data;

            setTimeValues(timeEntry.calendarDate, timeEntry.endTime, "endTime");

            if (startTimeDateObj.value !== null) {
                const {
                    hourDifference,
                    minuteDifference
                } = calculateDifference(
                    endTimeDateObj.value,
                    startTimeDateObj.value
                );
                if (minuteDifference >= 0 || hourDifference >= 0) {
                    setFormattedDuration(hourDifference, minuteDifference);
                } else {
                    timeEntry.duration = null;
                }
            }
        }

        function durationChanged(val) {
            const data = parseTimeDuration(val.target.value);
            timeEntry.duration = formatTimeDuration(data);

            const minutes =
                parseInt(timeEntry.duration.split(":")[0] * 60) +
                parseInt(timeEntry.duration.split(":")[1]);

            const hasOnlyStart = timeEntry.startTime !== null;
            const hasOnlyEnd = timeEntry.endTime !== null;
            const hasBothStartEnd =
                timeEntry.startTime !== null && timeEntry.endTime !== null;
            const hasNone =
                timeEntry.startTime === null && timeEntry.endTime === null;

            if (hasNone) {
                const unformattedStartTime = subMinutes(new Date(), minutes);

                timeEntry.endTime = formatSysTime(new Date());
                timeEntry.startTime = formatSysTime(unformattedStartTime);
            }
            if (hasBothStartEnd) {
                const unformattedEndTime = addMinutes(
                    startTimeDateObj.value,
                    minutes
                );
                timeEntry.endTime = formatSysTime(unformattedEndTime);
            }
            if (hasOnlyStart && !hasBothStartEnd) {
                const unformattedEndTime = addMinutes(
                    startTimeDateObj.value,
                    minutes
                );
                timeEntry.endTime = formatSysTime(unformattedEndTime);
            }
            if (hasOnlyEnd && !hasBothStartEnd) {
                const unformattedStartTime = subMinutes(
                    endTimeDateObj.value,
                    minutes
                );
                timeEntry.startTime = formatSysTime(unformattedStartTime);
            }
        }

        const date_changed = function (val) {
            timeEntry.calendarDate = val;
        };

        const locale = computed(function () {
            return Vue.formatting.culture;
        });

        const firstDayOfWeek = computed(function() {
            return Vue.formatting.first_week_day
        })

        const date_picked = function (val) {
            timeEntry.calendarDate = val;
            isCalendarOpen.value = false;
        };

        const validate_save_time_entry = function (time_entry) {
            let isValid = true;
            if (timeEntry.startTime === null) {
                error.value = $t("Required field");
                isValid = false;
            }
            if (timeEntry.endTime === null) {
                error.value = $t("Required field");
                isValid = false;
            }
            return isValid;
        };

        function toggle_billable() {
            if (timeEntry.billable === 1) {
                timeEntry.billable = 0;
            } else {
                timeEntry.billable = 1;
            }
        }

        function saveTimeEntry() {
            // send each item separately, because parent object is not always reactive
            saveTimeEntries(
                timeEntry.billable,
                timeEntry.startTime,
                timeEntry.endTime,
                timeEntry.duration,
                timeEntry.personId,
                timeEntry.calendarDate,
                splitDuration.value
            );
            menu_open.value = false;
        }

        // clear everything on close
        watch (
            () => menu_open.value,
            (newVal, oldVal) => {
                if (newVal === true && oldVal === false) {
                    timeEntry.startTime = null;
                    timeEntry.endTime = null;
                    timeEntry.duration = null;
                    timeEntry.billable = props.isBillable ? 1 : 0;
                    timeEntry.calendarDate = formatSysDate(new Date());
                    setTimeout(() => ctx.refs.durationInput.focus(), 100);
                }
            }, { immediate: true }
        );
        // these watches are needed to reactively set the converted date values(needed for calculations) when any of the input fields are changed
        watch (
            () => timeEntry.startTime,
            (newVal, oldVal) => {
                if (newVal === null) return;
                setTimeValues(timeEntry.calendarDate, newVal, "startTime");
            }, { immediate: true }
        );
        watch (
            () => timeEntry.endTime,
            (newVal, oldVal) => {
                if (newVal === null) return;

                setTimeValues(timeEntry.calendarDate, newVal, "endTime");
            }, { immediate: true }
        );

        return {
            timeEntry,
            menu_open,
            isCalendarOpen,
            inputOnFocus,
            locale,
            date_changed,
            date_picked,
            validate_save_time_entry,
            toggle_billable,
            error,
            formatTimeFromStr,
            startTimeChanged,
            endTimeChanged,
            durationChanged,
            splitDuration,
            saveTimeEntry,
            firstDayOfWeek,
            formatTime
        };
    }
};
</script>

<style scoped lang="scss">
.date-input {
    min-width: 115px;
    max-width: 115px;
}

.input-box {
    background: #f4f5f7;
    height: 40px;
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 14px;
}

.time-input {
    min-width: 85px;
    max-width: 85px;
}

.duration-input {
    min-width: 105px;
    max-width: 105px;
}

.card-container {
    max-width: 500px;
    max-height: 205px;
}
</style>
